import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import dayjs from "dayjs";
import { useGetProfileQuery } from "@/services/api/entities/profile";
import type { ProfileFormValues } from "../types";
import { getProfileSchema } from "../schema";

export const useProfileForm = () => {
  const { data: profile } = useGetProfileQuery();

  const formApi = useForm<ProfileFormValues>({
    resolver: yupResolver(getProfileSchema()),
  });

  // TODO: Need to refactor this
  useEffect(() => {
    if (profile) {
      formApi.reset({
        firstName: profile.firstName,
        secondName: profile.secondName,
        lastName: profile.lastName,
        birthday: profile.birthday ? dayjs(profile.birthday) : undefined,
        mobilePhone: profile.mobilePhone,
        email: profile.email,
      });
    }
  }, [profile, formApi]);

  return { formApi };
};
